import { _ } from "libs";
import React, { useEffect, useState } from "react";
import withRedux from "../../withRedux";
import { RootState } from "../../reducers";
import { updateProfile, flash } from "../../actions";
import { Profile, Connected } from "../../types";
import Loader from "../../components/loader";
import reactToString from "../../libs/reactToString";
import PrivacyForm from "../../components/settings/privacyForm";

type Props = {
	profile: Profile;
	updateProfile: Connected<typeof updateProfile>;
};

const Privacy = ({ profile, updateProfile }: Props) => {
	const onPrivacySettingsChange = (privacySettings: Profile["privacySettings"]) => {
		updateProfile({ privacySettings });
		flash(_("form.message.saved"));
	};

	return (
		<>
			<div className="privacySettings">
				<PrivacyForm profile={profile} onChange={onPrivacySettingsChange} />
			</div>
		</>
	);
};

export default withRedux({ updateProfile }, ({ profile }: RootState) => {
	return { profile };
})(Privacy);
